<div class="header-block">
  <h2>Driver Central</h2>
</div>
<!-- Driver Training Table -->
<div class="container-table">
  <div class="container-only-table">
    <div
      class="table-wrapper"
      *ngIf="!isLoadingTraining && trainingDataFiltered.length > 0"
    >
      <table
        mat-table
        matSort
        (matSortChange)="announceTrainingSortChange($event)"
        [dataSource]="trainingDataFiltered"
        class="intervention-table"
      >
        <ng-container matColumnDef="formType">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Form Type</th>
          <td mat-cell *matCellDef="let item">{{ item.formType }}</td>
        </ng-container>

        <ng-container matColumnDef="topic">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Topic</th>
          <td mat-cell *matCellDef="let item">{{ item.topic }}</td>
        </ng-container>

        <ng-container matColumnDef="coach">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Coach</th>
          <td mat-cell *matCellDef="let item">{{ item.coach }}</td>
        </ng-container>

        <ng-container matColumnDef="creationDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Creation Date</th>
          <td mat-cell *matCellDef="let item">{{ item.creationDate }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="trainingColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: trainingColumns"
          (click)="openDetailsModal(row)"
          class="clickable-row"
        ></tr>
      </table>
    </div>

    <div *ngIf="isLoadingTraining" class="spinner-overlay">
      <mat-progress-spinner
        mode="indeterminate"
        [diameter]="30"
        class="spinner"
      ></mat-progress-spinner>
    </div>

    <div class="paginator-container" *ngIf="!isViewMoreTraining">
      <div class="paginator-text">
        Showing {{ startPageIdx }} - {{ endPageIdx }} of {{ totalRecordCount }} items
      </div>
      <mat-paginator
        [pageSize]="pageEvent.pageSize"
        [length]="paginationParams.total"
        [hidePageSize]="true"
        [pageIndex]="pageEvent.pageIndex"
        (page)="onPageChange($event)"
      >
      </mat-paginator>
    </div>

    <div
      *ngIf="!isLoadingTraining && trainingDataFiltered.length === 0"
      class="no-records-found"
    >
      <p>No records found.</p>
    </div>

    <hr *ngIf="!isLoadingTraining && showViewMoreTraining" />

    <div
      class="view-more"
      *ngIf="!isLoadingTraining && showViewMoreTraining"
      (click)="loadMore()"
    >
      <span>{{ isViewMoreTraining ? "View More" : "View Less" }}</span>
      <mat-icon matIconSuffix>{{
        isViewMoreTraining ? "expand_more" : "expand_less"
      }}</mat-icon>
    </div>
  </div>
</div>
